import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import {connect} from 'react-redux';
import {getStart} from '../../../v2/selectors/selectors';
import MultibancoPaymentInformation from './MultibancoPaymentInformation/MultibancoPaymentInformation';

const useStyles = createUseStyles({
  paymentInformation: {
    margin: [0, 'auto', 15, 'auto'],
    width: '90%',
    textAlign: 'left',
  },
});

export function PaymentInformation(props) {
  const classes = useStyles();
  
  if (props.paymentMethod === 'MULTIBANCO') {
    return (
      <div className={classes.paymentInformation} data-test="PaymentInformation">
        <MultibancoPaymentInformation />
      </div>
    );
  }
  return null;
}

const mapStateToProps = state => ({
  paymentMethod: getStart(state).selectedPaymentMethod,
});

PaymentInformation.propTypes = {
  paymentMethod: PropTypes.string.isRequired,
};

export default connect(
  mapStateToProps,
)(PaymentInformation);
